import { createMotionVars } from "./motionVars";
import { createFomoSectionTransition } from "./sectionMotion";
import { createFomoBenefits } from "./benefitsMotion";
import { createFomoDecision } from "./decisionMotion";
import { createMotionScope } from "./motionScope";
export function mountLaunchMotion(root) {
  const { listen, animate, observeSize, observeReveal, frame, delay, dispose } =
    createMotionScope();
  root.classList.add("js");
  const $ = (s) => root.querySelector(s),
    $$ = (s) => [...root.querySelectorAll(s)];
  const clamp = (x, min = 0, max = 1) => Math.max(min, Math.min(max, x));
  const lerp = (a, b, p) => a + (b - a) * p;
  const ease = (p) => p * p * (3 - 2 * p);
  const media = matchMedia("(prefers-reduced-motion: reduce)");
  const track = $(".story-track"),
    theatre = $(".product-theatre"),
    pass = $("#journey-pass");
  const videos = $$("video");
  let paused = media.matches,
    chapter = -1,
    phase = 0,
    manualChapter = 0,
    framePending = false,
    scanOverride = false,
    scanTimeout,
    scanning = false;
  const benefitExperience = createFomoBenefits({
    root,
    listen,
    observeSize,
    isPaused: () => paused,
    isReduced: () => media.matches,
    requestUpdate,
  });
  const decisionExperience = createFomoDecision({
    root,
    listen,
    animate,
    isPaused: () => paused,
    isReduced: () => media.matches,
    requestUpdate,
  });
  const sectionExperience = createFomoSectionTransition({
    frame: $(".story-frame"),
    sticky: $(".story-sticky"),
    incoming: $(".benefit-sticky"),
    header: $(".site-header"),
    isStill: () => paused || media.matches,
  });
  const header = $(".site-header"),
    sticky = $(".story-sticky");
  const hero = $(".hero"),
    heroLight = $(".hero-light"),
    aura = $(".ticket-aura");
  const moneySection = $(".money-section"),
    closing = $(".closing");
  const closingPhoto = $(".closing-photo"),
    readingProgress = $(".reading-progress");
  const chapterBars = $$(".chapter-nav button i"),
    accessTitle = $("#access-title");
  const setMotion = createMotionVars(theatre, () => chapter);
  let geometry = {},
    measureNeeded = true,
    lastStory = "",
    lastHero = -1;
  let lastMoney = "",
    lastClosing = -1,
    videoPlaying = null;
  function measureLayout() {
    const bounds = (el) => ({
      top: el.getBoundingClientRect().top + scrollY,
      height: el.offsetHeight,
    });
    geometry = {
      viewport: innerHeight,
      header: header.offsetHeight,
      track: bounds(track),
      sticky: sticky.offsetHeight,
      theatreWidth: theatre.clientWidth,
      theatreHeight: theatre.clientHeight,
      hero: bounds(hero),
      money: bounds(moneySection),
      closing: bounds(closing),
      documentHeight: document.documentElement.scrollHeight,
      compact: innerWidth <= 600,
    };
    sectionExperience.measure();
    benefitExperience.measure();
    lastStory = "";
    lastHero = -1;
    lastClosing = -1;
    measureNeeded = false;
  }
  function invalidateLayout() {
    measureNeeded = true;
    requestUpdate();
  }
  const keys = [
    {
      t: 0,
      x: 0.06,
      y: 0.08,
      s: 0.68,
      r: -18,
      ry: -28,
      o: 1,
    },
    {
      t: 0.14,
      x: 0.02,
      y: -0.02,
      s: 1.14,
      r: 3,
      ry: 9,
      o: 1,
    },
    {
      t: 0.2,
      x: 0,
      y: -0.025,
      s: 1.1,
      r: -3,
      ry: -5,
      o: 1,
    },
    {
      t: 0.29,
      x: -0.4,
      y: 0.2,
      s: 0.35,
      r: -12,
      ry: -8,
      o: 0.9,
    },
    {
      t: 0.46,
      x: -0.4,
      y: 0.23,
      s: 0.34,
      r: -8,
      ry: 0,
      o: 0.85,
    },
    {
      t: 0.53,
      x: 0.3,
      y: 0.25,
      s: 0.3,
      r: 12,
      ry: 0,
      o: 0,
    },
    {
      t: 0.7,
      x: 0.3,
      y: 0.25,
      s: 0.3,
      r: 12,
      ry: 0,
      o: 0,
    },
    {
      t: 0.78,
      x: 0.03,
      y: -0.11,
      s: 0.55,
      r: 5,
      ry: -18,
      o: 1,
    },
    {
      t: 0.94,
      x: 0.03,
      y: -0.11,
      s: 1.04,
      r: 0,
      ry: 0,
      o: 1,
    },
    {
      t: 1,
      x: 0.03,
      y: -0.11,
      s: 1.08,
      r: 0,
      ry: 0,
      o: 1,
    },
  ];
  function interpolate(p) {
    let a = keys[0],
      b = keys[keys.length - 1];
    for (let i = 1; i < keys.length; i++) {
      if (p <= keys[i].t) {
        a = keys[i - 1];
        b = keys[i];
        break;
      }
    }
    const q = ease(clamp((p - a.t) / (b.t - a.t)));
    return Object.fromEntries(
      ["x", "y", "s", "r", "ry", "o"].map((k) => [k, lerp(a[k], b[k], q)])
    );
  }
  function setChapter(next) {
    if (next === chapter) return;
    chapter = next;
    theatre.dataset.scene = String(next);
    $("#scene-count").textContent = String(next + 1).padStart(2, "0");
    $$("[data-copy]").forEach((el) => {
      const active = Number(el.dataset.copy) === next;
      el.classList.toggle("is-active", active);
      el.setAttribute("aria-hidden", String(!active));
      el.inert = !active;
    });
    $$("[data-layer]").forEach((el) => {
      const active = Number(el.dataset.layer) === next;
      el.classList.toggle("is-active", active);
      el.setAttribute("aria-hidden", String(!active));
      el.inert = !active;
    });
    $$("[data-chapter]").forEach((el) =>
      el.setAttribute(
        "aria-pressed",
        String(Number(el.dataset.chapter) === next)
      )
    );
  }
  function update() {
    framePending = false;
    if (measureNeeded) measureLayout();
    const g = geometry,
      still = paused || media.matches;
    const length = Math.max(
      1,
      g.track.height - Math.max(g.viewport - g.header, g.sticky)
    );
    const p = media.matches
      ? (manualChapter + 0.7) / 4
      : clamp((scrollY - g.track.top + g.header) / length);
    const raw = p * 4,
      next = Math.min(3, Math.floor(raw));
    phase = still ? 0.85 : raw >= 4 ? 1 : raw - next;
    const storyKey = `${p.toFixed(4)}|${still}|${scanOverride}|${scanning}`;
    if (lastStory !== storyKey) {
      lastStory = storyKey;
      sectionExperience.prepare(next);
      setChapter(next);
      // Let the whole screen begin its approach before unfolding the product.
      // Finish early so the remaining scroll is stable reading / interaction.
      const stepPhase = still
        ? 1
        : ease(clamp((phase - 0.05) / (g.compact ? 0.32 : 0.52)));
      setMotion("--phase", stepPhase.toFixed(3));
      setMotion("--foil-shift", (-50 + stepPhase * 100).toFixed(2) + "%");
      setMotion(
        "--qr-focus",
        next === 3 ? ease(clamp((phase - 0.5) / 0.36)).toFixed(3) : "0"
      );
      const transform = interpolate(still ? (next + 0.77) / 4 : p);
      pass.style.transform = `translate(-50%,-50%) translate3d(${
        transform.x * g.theatreWidth
      }px,${transform.y * g.theatreHeight}px,0) scale(${transform.s}) rotate(${
        transform.r
      }deg) rotateY(${transform.ry}deg)`;
      pass.style.opacity = transform.o.toFixed(3);
      const scan = clamp((phase - 0.1) / 0.66);
      const valid = scanning
        ? 0
        : scanOverride
        ? 1
        : ease(clamp((phase - 0.64) / 0.22));
      setMotion("--scan", scan.toFixed(3));
      setMotion("--valid", valid.toFixed(3));
      setMotion("--scan-opacity", scanOverride || phase > 0.84 ? "0" : "1");
      const title = valid > 0.7 ? "Acceso validado" : "Entrada reconocida";
      if (!scanning && accessTitle.textContent !== title)
        accessTitle.textContent = title;
      chapterBars.forEach((bar, index) => {
        bar.style.transform = `scaleX(${
          index === next ? phase.toFixed(3) : 0
        })`;
      });
    }
    sectionExperience.update(phase);

    const heroProgress = still
      ? 0
      : clamp((scrollY - g.hero.top) / g.hero.height);
    if (heroProgress !== lastHero) {
      lastHero = heroProgress;
      const h = heroProgress;
      heroObject.style.transform = g.compact
        ? `translate3d(0,${-16 * h}px,0) scale(${1.04 - h * 0.045})`
        : `translate3d(0,${-70 * h}px,0) scale(${1.08 - h * 0.13})`;
      heroLight.style.transform = `translate3d(0,${-65 * h}px,0)`;
      aura.style.transform = `scale(${1 + h * 0.22})`;
      videos.forEach((video) => {
        video.style.transform = g.compact
          ? "none"
          : `translate3d(0,${h * 65}px,0) scale(${1.035 + h * 0.13})`;
      });
    }
    const reading = clamp(scrollY / Math.max(1, g.documentHeight - g.viewport));
    readingProgress.style.transform = `scaleX(${reading.toFixed(4)})`;
    header.classList.toggle("scrolled", scrollY > 30);
    syncVideo();
    benefitExperience.update();
    const moneyProgress = still
      ? "1"
      : ease(
          clamp(
            (g.viewport - (g.money.top - scrollY) - g.viewport * 0.12) /
              (Math.min(g.money.height, g.viewport) * 0.78)
          )
        ).toFixed(3);
    if (moneyProgress !== lastMoney) {
      lastMoney = moneyProgress;
      moneySection.style.setProperty("--money", moneyProgress);
    }
    decisionExperience.update(moneyProgress);
    const closingProgress = still
      ? 1
      : clamp(
          (g.viewport - (g.closing.top - scrollY)) /
            (g.viewport + g.closing.height)
        );
    if (closingProgress !== lastClosing) {
      lastClosing = closingProgress;
      closingPhoto.style.transform = `scale(${
        1.12 - closingProgress * 0.12
      }) translate3d(0,${(1 - closingProgress) * -20}px,0)`;
    }
  }
  function syncVideo() {
    const visible =
      !document.hidden &&
      !paused &&
      !media.matches &&
      (!geometry.hero || scrollY < geometry.hero.top + geometry.hero.height);
    if (visible === videoPlaying) return;
    videoPlaying = visible;
    videos.forEach((video) =>
      visible ? video.play().catch(() => {}) : video.pause()
    );
  }
  function requestUpdate() {
    if (!framePending) {
      framePending = true;
      frame(update);
    }
  }
  listen(window, "scroll", requestUpdate, {
    passive: true,
  });
  listen(window, "resize", invalidateLayout, {
    passive: true,
  });
  observeSize(root, invalidateLayout);
  observeSize(theatre, invalidateLayout);
  // Late font/asset layout above the sticky tracks can move their document
  // offsets without resizing the theatre or changing the page's total height.
  observeSize(hero, invalidateLayout);
  observeSize($(".benefit-rail"), invalidateLayout);
  observeSize(header, invalidateLayout);
  listen(document.fonts, "loadingdone", invalidateLayout);
  document.fonts.ready.then(invalidateLayout);
  const reveal = observeReveal(
    (entries) =>
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("revealed");
          reveal.unobserve(entry.target);
        }
      }),
    {
      threshold: 0.12,
    }
  );
  $$("[data-reveal]").forEach((el) => reveal.observe(el));
  function gotoChapter(index) {
    manualChapter = clamp(index, 0, 3);
    if (media.matches) {
      update();
      track.scrollIntoView({
        behavior: "auto",
        block: "start",
      });
      return;
    }
    const headerHeight = $(".site-header").offsetHeight,
      top = track.getBoundingClientRect().top + scrollY;
    const length = track.offsetHeight - $(".story-sticky").offsetHeight;
    window.scrollTo({
      top: top - headerHeight + length * ((manualChapter + 0.45) / 4),
      behavior: paused ? "auto" : "smooth",
    });
  }
  $$("[data-chapter]").forEach((button) =>
    listen(button, "click", () => gotoChapter(Number(button.dataset.chapter)))
  );
  $$("[data-go-scene]").forEach((link) =>
    listen(link, "click", (event) => {
      event.preventDefault();
      gotoChapter(Number(link.dataset.goScene));
    })
  );
  $$("[data-tour]").forEach((button) =>
    listen(button, "click", () => gotoChapter(0))
  );
  const zones = {
    pista: "Pista general",
    mesas: "Mesas VIP",
    gradas: "Gradas",
  };
  function selectZone(zone) {
    $("#selected-zone").textContent = zones[zone];
    $("#journey-zone").textContent = zones[zone];
    $("#access-detail").textContent =
      "AFTER HOURS · " + zones[zone] + " · Demo";
    $$("[data-zone]").forEach((button) =>
      button.setAttribute("aria-pressed", String(button.dataset.zone === zone))
    );
    $$("[data-map-zone]").forEach((el) => {
      const selected = el.dataset.mapZone === zone;
      el.style.opacity = selected ? "1" : ".46";
      el.classList.toggle("is-selected", selected);
    });
  }
  $$("[data-zone]").forEach((button) =>
    listen(button, "click", () => selectZone(button.dataset.zone))
  );
  const sales = {
    preventa: [42, 27, 15],
    general: [31, 19, 12],
  };
  $$("[data-sale]").forEach((button) =>
    listen(button, "click", () => {
      const values = sales[button.dataset.sale],
        total = values.reduce((a, b) => a + b, 0);
      $("#sales-count").textContent = total;
      $("#sales-revenue").textContent =
        "$" +
        (total * (button.dataset.sale === "preventa" ? 15 : 25)).toLocaleString(
          "es-EC"
        );
      $("#sales-occupancy").textContent = Math.round((total / 120) * 100) + "%";
      $$("[data-sale]").forEach((el) =>
        el.setAttribute("aria-pressed", String(el === button))
      );
      $$(".sales-row").forEach((row, index) => {
        row.querySelector("b").textContent = values[index];
        row
          .querySelector("i")
          .style.setProperty("--bar", values[index] * 2 + "%");
      });
    })
  );
  listen($("#scan-demo"), "click", () => {
    const button = $("#scan-demo");
    clearTimeout(scanTimeout);
    scanOverride = false;
    scanning = true;
    button.disabled = true;
    $("#access-title").textContent = "Validando QR…";
    setMotion("--valid", "0");
    const line = $(".scanner-line");
    line.style.opacity = "1";
    const duration = paused || media.matches ? 0 : 950;
    const anim = animate(
      line,
      [
        {
          top: "18%",
        },
        {
          top: "76%",
        },
      ],
      {
        duration,
        easing: "ease-in-out",
      }
    );
    scanTimeout = delay(() => {
      anim.cancel();
      line.style.opacity = "";
      scanOverride = true;
      scanning = false;
      button.disabled = false;
      button.querySelector("span").textContent = "Repetir escaneo";
      lastStory = "";
      update();
    }, duration);
  });
  function applyMotion() {
    root.classList.toggle("motion-paused", paused);
    syncVideo();
    measureNeeded = true;
    requestUpdate();
  }
  listen(media, "change", () => {
    paused = media.matches;
    applyMotion();
  });
  const heroObject = $("#hero-object"),
    heroPass = $(".hero-pass");
  listen(heroPass, "animationend", () => (heroPass.style.animation = "none"), {
    once: true,
  });
  listen(heroObject, "pointermove", (event) => {
    if (paused || media.matches || event.pointerType === "touch") return;
    const rect = heroObject.getBoundingClientRect(),
      x = (event.clientX - rect.left) / rect.width - 0.5,
      y = (event.clientY - rect.top) / rect.height - 0.5;
    heroPass.style.transform = `rotate(${-10 + x * 8}deg) rotateY(${
      -18 + x * 24
    }deg) rotateX(${7 - y * 12}deg) translateY(12px)`;
  });
  listen(heroObject, "pointerleave", () => (heroPass.style.transform = ""));
  listen($("[data-money-faq]"), "click", () => ($("#faq-money").open = true));
  listen(document, "visibilitychange", syncVideo);
  listen(root, "click", (event) => {
    const link = event.target.closest('a[href^="#"]');
    if (
      !link ||
      event.defaultPrevented ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    )
      return;
    const target = root.querySelector(link.getAttribute("href"));
    if (target) {
      event.preventDefault();
      target.scrollIntoView({
        behavior: paused || media.matches ? "instant" : "smooth",
      });
    }
  });
  selectZone("pista");
  applyMotion();
  update();
  root.dataset.ready = "true";
  return () => {
    videos.forEach((video) => video.pause());
    sectionExperience.destroy();
    dispose();
  };
}
